module.exports = __webpack_public_path__ + "static/media/0520-a-r-en.4c1b226c.png";